import React from 'react';
import { Card } from 'antd';
import './style.less';

const SectionWrapper = ({ id, title, children, right }) => (
  <section id={id} className="component-section">
    <Card className="component-section" bordered={false} title={title} extra={right}>
      {children}
    </Card>
  </section>
);

export default SectionWrapper;
